import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faChartBar,
  faQrcode,
  faGear,
} from "@fortawesome/free-solid-svg-icons";

const adminNavItems = [
  { path: "/dashboard",   icon: faHome,     label: "Home" },
  { path: "/settings",    icon: faGear,     label: "Settings" },
  { path: "/public-link", icon: faQrcode,   label: "Public" },
  { path: "/report",      icon: faChartBar, label: "Report" },
];

const waiterNavItems = [
  { path: "/dashboard", icon: faHome, label: "Home" },
];

function BottomNav({ isAdmin = true, isWaiter = false }) {
  const location = useLocation();
  const navItems = isWaiter ? waiterNavItems : adminNavItems;

  const isActive = (path) => {
    if (path === "/addUser/0") return location.pathname.startsWith("/addUser");
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white shadow-nav z-50">
      <div className="max-w-md mx-auto flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full gap-0.5 ${
                active ? "text-primary" : "text-gray-400"
              }`}
            >
              <div className={`flex items-center justify-center w-10 h-7 rounded-full ${active ? "bg-primary-bg" : ""}`}>
                <FontAwesomeIcon icon={item.icon} className="text-base" />
              </div>
              <span className={`text-xs ${active ? "font-semibold" : "font-medium"}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNav;
